import React, { useEffect, useState } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Row, Col, Button, Form, Modal, TreeSelect, useCRUDController } from '../../ui/ot'

const { confirm } = Modal;
const DepartmentRole = ({
    propsForm,
    field,
    remove,//不送就不會出現remove按鈕
    defaultDepartment,
    defaultRole,
    showMode,    //可供呈現一個結構體
    showLabel = false,//form的標籤
    onDepartmentRoleChange = () => { },
    departmentPlaceholder = "選擇部門",
    propsDepartmentClassifyStructureTypeId,
    name,
    value,
    onChange = () => { },
    onValueChange = () => { },
    required = true,
    propsDepartmentController,
    propsDepartmentOptionController,
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ?? form_
    const [count, setCount] = useState(0);
    const departmentController_ = useCRUDController({
        apiRoute: '/organization_structure/api/department_dropdown'
    })
    const departmentController = propsDepartmentController ?? departmentController_
    const departmentOptionController_ = useCRUDController({
        apiRoute: '/organization_structure/api/department'
    })
    const departmentOptionController = (propsDepartmentOptionController ?? departmentOptionController_)

    useEffect(() => {
        if (departmentOptionController?.ResponseData?.length === 0) {
            departmentOptionController.getData({
                all: true
            })
        }
        if (departmentController?.ResponseData?.length === 0) {
            departmentController.getData({
                classify_structure_type_id: 0,
                classify_structure_id: 9
            })
        }
        setTimeout(() => {
            setCount(pre => pre + 1)
        }, 1000)
    }, []);

    return (

        <Row gutter={[4, 4]} style={{ display: 'flex', justify: 'center', alignItems: 'center' }}>

            <Col span={remove !== undefined ? 20 : 24}>
                {departmentController.ResponseData.length !== 0 && (showMode === undefined || showMode === 'department') && <>
                    <TreeSelect
                        // defaultValue={
                        //     departmentId
                        // }
                        // showSearch/
                        style={{
                            width: '100%',
                        }}
                        // value={value}
                        dropdownStyle={{
                            maxHeight: 400,
                            overflow: 'auto',
                        }}
                        placeholder={departmentPlaceholder}
                        allowClear
                        treeDefaultExpandAll
                        treeNodeFilterProp={"title"}
                        name={name}
                        value={departmentOptionController.ResponseData?.find(item => String(item?.department_id) === String(value))?.classify_structure_type_id}
                        onChange={(e) => {
                            console.log({
                                ...e,
                                target: {
                                    name,
                                    value: departmentOptionController.ResponseData?.find(item => String(item?.classify_structure_type_id) === String(e.target.value))?.department_id
                                }
                            })
                            onChange({
                                ...e,
                                target: {
                                    name,
                                    value: departmentOptionController.ResponseData?.find(item => String(item?.classify_structure_type_id) === String(e.target.value))?.department_id
                                }
                            })
                        }}
                        onValueChange={(e) => {
                            onValueChange({
                                ...e,
                                target: {
                                    name,
                                    value: departmentOptionController.ResponseData?.find(item => String(item?.classify_structure_type_id) === String(e.target.value))?.department_id
                                }
                            })
                        }}
                        treeData={departmentController.ResponseData?.filter(item => propsDepartmentClassifyStructureTypeId !== undefined ? item?.classify_structure_type_id === propsDepartmentClassifyStructureTypeId : true)}
                        minWidth='200%'
                    />
                </>}
            </Col>
            <Col span={remove !== undefined ? 4 : 0}>
                <Button
                    onClick={() => {
                        confirm({
                            title: '確定要刪除嗎',
                            icon: <ExclamationCircleOutlined />,
                            okText: '確定',
                            okType: 'danger',
                            cancelText: '取消',
                            onOk() {
                                remove(field.name);
                            },
                            centered: true
                        });
                    }}> 刪除
                </Button>
            </Col>
        </Row>

    )
}
export default DepartmentRole;

